export const countries = ["Antarctica",
	"United Arab Emirates",
	"Afghanistan",
   "Antigua and Barbuda",
   "Anguilla",
   "Albania",
   "Armenia",
   "Angola",
   "Argentina",
   "American Samoa",
   "Austria",
   "Australia",
   "Aruba",
   "Aland Islands",
   "Azerbaijan",
   "Bosnia and Herzegovina",
   "Barbados",
   "Bangladesh",
   "Belgium",
   "Burkina Faso",
   "Bulgaria",
   "Bahrain",
   "Burundi",
   "Benin",
   "Saint Barthelemy",
   "Brunei Darussalam",
   "Bolivia",
   "Bermuda",
   "Bonaire, Saint Eustachius and Saba",
   "Brazil",
   "Bahamas",
   "Bhutan",
   "Bouvet Island",
   "Botswana",
   "Belarus",
   "Belize",
   "Canada",
   "Cocos (Keeling) Islands",
   "Congo",
   "Central African Republic",
   "Republic of Congo",
   "Switzerland",
   "Côte d'Ivoire",
   "Cook Islands",
   "Chile",
   "Cameroon",
   "China",
   "Colombia",
   "Costa Rica",
   "Cuba",
   "Cape Verde",
   "Curaçao",
   "Christmas Island",
   "Cyprus",
   "Czech Republic",
   "Germany",
   "Djibouti",
   "Denmark",
   "Dominica",
   "Dominican Republic",
   "Algeria",
   "Ecuador",
   "Egypt",
   "Estonia",
   "Western Sahara",
   "Eritrea",
   "Spain",
   "Ethiopia",
   "Finland",
   "Fiji",
   "Falkland Islands",
   "Micronesia",
   "Faroe Islands",
   "France",
   "Gabon",
   "United Kingdom",
   "Georgia",
   "Grenada",
   "French Guiana",
   "Guernsey",
   "Ghana",
   "Gibraltar",
   "Greenland",
   "Gambia",
   "Guinea",
   "Glorioso Islands",
   "Guadeloupe",
   "Equatorial Guinea",
   "Greece",
   "South Georgia and South Sandwich Islands",
   "Guatemala",
   "Guam",
   "Guinea-Bissau",
   "Guyana",
   "Hong Kong",
   "Heard Island and McDonald Islands",
   "Honduras",
   "Croatia",
   "Haiti",
   "Hungary",
   "Indonesia",
   "Ireland",
   "Israel",
   "Isle of Man",
   "India",
   "British Indian Ocean Territory",
   "Iraq",
   "Iran",
   "Iceland",
   "Italy",
   "Jersey",
   "Jamaica",
   "Jordan",
   "Japan",
   "Juan De Nova Island",
   "Kenya",
   "Kyrgyzstan",
   "Cambodia",
   "Kiribati",
   "Comoros",
   "Saint Kitts and Nevis",
   "North Korea",
   "South Korea",
   "Kosovo",
   "Kuwait",
   "Cayman Islands",
   "Kazakhstan",
   "Laos",
   "Lebanon",
   "Saint Lucia",
   "Liechtenstein",
   "Sri Lanka",
   "Liberia",
   "Lesotho",
   "Lithuania",
   "Luxembourg",
   "Latvia",
   "Libya",
   "Morocco",
   "Monaco",
   "Moldova",
   "Madagascar",
   "Montenegro",
   "Saint Martin",
   "Marshall Islands",
   "Macedonia",
   "Mali",
   "Macau",
   "Myanmar",
   "Mongolia",
   "Northern Mariana Islands",
   "Martinique",
   "Mauritania",
   "Montserrat",
   "Malta",
   "Mauritius",
   "Maldives",
   "Malawi",
   "Mexico",
   "Malaysia",
   "Mozambique",
   "Namibia",
   "New Caledonia",
   "Niger",
   "Norfolk Island",
   "Nigeria",
   "Nicaragua",
   "Netherlands",
   "Norway",
   "Nepal",
   "Nauru",
   "Niue",
   "New Zealand",
   "Oman",
   "Panama",
   "Peru",
   "French Polynesia",
   "Papua New Guinea",
   "Philippines",
   "Pakistan",
   "Poland",
   "Saint Pierre and Miquelon",
   "Pitcairn Islands",
   "Puerto Rico",
   "Palestinian Territories",
   "Portugal",
   "Palau",
   "Paraguay",
   "Qatar",
   "Reunion",
   "Romania",
   "Serbia",
   "Russia",
   "Rwanda",
   "Saudi Arabia",
   "Solomon Islands",
   "Seychelles",
   "Sudan",
   "Sweden",
   "Singapore",
   "Saint Helena",
   "Slovenia",
   "Svalbard and Jan Mayen",
   "Slovakia",
   "Sierra Leone",
   "San Marino",
   "Senegal",
   "Somalia",
   "Suriname",
   "South Sudan",
   "Sao Tome and Principe",
   "El Salvador",
   "Saint Martin",
   "Syria",
   "Swaziland",
   "Turks and Caicos Islands",
   "Chad",
   "French Southern and Antarctic Lands",
   "Togo",
   "Thailand",
   "Tajikistan",
   "Tokelau",
   "Timor-Leste",
   "Turkmenistan",
   "Tunisia",
   "Tonga",
   "Turkey",
   "Trinidad and Tobago",
   "Tuvalu",
   "Taiwan",
   "Tanzania",
   "Ukraine",
   "Uganda",
   "Jarvis Island",
   "Baker Island",
   "Howland Island",
   "Johnston Atoll",
   "Midway Islands",
   "Wake Island",
   "United States",
   "Uruguay",
   "Uzbekistan",
   "Vatican City",
   "Saint Vincent and the Grenadines",
   "Venezuela",
   "British Virgin Islands",
   "US Virgin Islands",
   "Vietnam",
   "Vanuatu",
   "Wallis and Futuna",
   "Samoa",
   "Yemen",
   "Mayotte",
   "South Africa",
   "Zambia",
   "Zimbabwe"
   ];
   
export const countries_continents = [{
	"continent": "Asia",
	"country": "United Arab Emirates",
	"region": "ae"
}, {
	"continent": "Asia",
	"country": "Afghanistan",
	"region": "af"
}, {
	"continent": "North America",
	"country": "Antigua and Barbuda",
	"region": "ag"
}, {
	"continent": "North America",
	"country": "Anguilla",
	"region": "ai"
}, {
	"continent": "Europe",
	"country": "Albania",
	"region": "al"
}, {
	"continent": "Europe",
	"country": "Armenia",
	"region": "am"
}, {
	"continent": "Africa",
	"country": "Angola",
	"region": "ao"
}, {
	"continent": "South America",
	"country": "Argentina",
	"region": "ar"
}, {
	"continent": "Oceania",
	"country": "American Samoa",
	"region": "as"
}, {
	"continent": "Europe",
	"country": "Austria",
	"region": "at"
}, {
	"continent": "Oceania",
	"country": "Australia",
	"region": "au"
}, {
	"continent": "South America",
	"country": "Aruba",
	"region": "aw"
}, {
	"continent": "Europe",
	"country": "Aland Islands",
	"region": "ax"
}, {
	"continent": "Europe",
	"country": "Azerbaijan",
	"region": "az"
}, {
	"continent": "Europe",
	"country": "Bosnia and Herzegovina",
	"region": "ba"
}, {
	"continent": "North America",
	"country": "Barbados",
	"region": "bb"
}, {
	"continent": "Asia",
	"country": "Bangladesh",
	"region": "bd"
}, {
	"continent": "Europe",
	"country": "Belgium",
	"region": "be"
}, {
	"continent": "Africa",
	"country": "Burkina Faso",
	"region": "bf"
}, {
	"continent": "Europe",
	"country": "Bulgaria",
	"region": "bg"
}, {
	"continent": "Asia",
	"country": "Bahrain",
	"region": "bh"
}, {
	"continent": "Africa",
	"country": "Burundi",
	"region": "bi"
}, {
	"continent": "Africa",
	"country": "Benin",
	"region": "bj"
}, {
	"continent": "North America",
	"country": "Saint Barthelemy",
	"region": "bl"
}, {
	"continent": "Asia",
	"country": "Brunei Darussalam",
	"region": "bn"
}, {
	"continent": "South America",
	"country": "Bolivia",
	"region": "bo"
}, {
	"continent": "North America",
	"country": "Bermuda",
	"region": "bm"
}, {
	"continent": "South America",
	"country": "Bonaire, Saint Eustachius and Saba",
	"region": "bq"
}, {
	"continent": "South America",
	"country": "Brazil",
	"region": "br"
}, {
	"continent": "North America",
	"country": "Bahamas",
	"region": "bs"
}, {
	"continent": "Asia",
	"country": "Bhutan",
	"region": "bt"
}, {
	"continent": "Antarctica",
	"country": "Bouvet Island",
	"region": "bv"
}, {
	"continent": "Africa",
	"country": "Botswana",
	"region": "bw"
}, {
	"continent": "Europe",
	"country": "Belarus",
	"region": "by"
}, {
	"continent": "North America",
	"country": "Belize",
	"region": "bz"
}, {
	"continent": "North America",
	"country": "Canada",
	"region": "ca"
}, {
	"continent": "Asia",
	"country": "Cocos (Keeling) Islands",
	"region": "cc"
}, {
	"continent": "Africa",
	"country": "Congo",
	"region": "cd"
}, {
	"continent": "Africa",
	"country": "Central African Republic",
	"region": "cf"
}, {
	"continent": "Africa",
	"country": "Republic of Congo",
	"region": "cg"
}, {
	"continent": "Europe",
	"country": "Switzerland",
	"region": "ch"
}, {
	"continent": "Africa",
	"country": "Côte d'Ivoire",
	"region": "ci"
}, {
	"continent": "Oceania",
	"country": "Cook Islands",
	"region": "ck"
}, {
	"continent": "South America",
	"country": "Chile",
	"region": "cl"
}, {
	"continent": "Africa",
	"country": "Cameroon",
	"region": "cm"
}, {
	"continent": "Asia",
	"country": "China",
	"region": "cn"
}, {
	"continent": "South America",
	"country": "Colombia",
	"region": "co"
}, {
	"continent": "North America",
	"country": "Costa Rica",
	"region": "cr"
}, {
	"continent": "North America",
	"country": "Cuba",
	"region": "cu"
}, {
	"continent": "Africa",
	"country": "Cape Verde",
	"region": "cv"
}, {
	"continent": "South America",
	"country": "Curaçao",
	"region": "cw"
}, {
	"continent": "Asia",
	"country": "Christmas Island",
	"region": "cx"
}, {
	"continent": "Europe",
	"country": "Cyprus",
	"region": "cy"
}, {
	"continent": "Europe",
	"country": "Czech Republic",
	"region": "cz"
}, {
	"continent": "Europe",
	"country": "Germany",
	"region": "de"
}, {
	"continent": "Africa",
	"country": "Djibouti",
	"region": "dj"
}, {
	"continent": "Europe",
	"country": "Denmark",
	"region": "dk"
}, {
	"continent": "North America",
	"country": "Dominica",
	"region": "dm"
}, {
	"continent": "North America",
	"country": "Dominican Republic",
	"region": "do"
}, {
	"continent": "Africa",
	"country": "Algeria",
	"region": "dz"
}, {
	"continent": "South America",
	"country": "Ecuador",
	"region": "ec"
}, {
	"continent": "Africa",
	"country": "Egypt",
	"region": "eg"
}, {
	"continent": "Europe",
	"country": "Estonia",
	"region": "ee"
}, {
	"continent": "Africa",
	"country": "Western Sahara",
	"region": "eh"
}, {
	"continent": "Africa",
	"country": "Eritrea",
	"region": "er"
}, {
	"continent": "Europe",
	"country": "Spain",
	"region": "es"
}, {
	"continent": "Africa",
	"country": "Ethiopia",
	"region": "et"
}, {
	"continent": "Europe",
	"country": "Finland",
	"region": "fi"
}, {
	"continent": "Oceania",
	"country": "Fiji",
	"region": "fj"
}, {
	"continent": "South America",
	"country": "Falkland Islands",
	"region": "fk"
}, {
	"continent": "Oceania",
	"country": "Micronesia",
	"region": "fm"
}, {
	"continent": "Europe",
	"country": "Faroe Islands",
	"region": "fo"
}, {
	"continent": "Europe",
	"country": "France",
	"region": "fr"
}, {
	"continent": "Africa",
	"country": "Gabon",
	"region": "ga"
}, {
	"continent": "Europe",
	"country": "United Kingdom",
	"region": "gb"
}, {
	"continent": "Europe",
	"country": "Georgia",
	"region": "ge"
}, {
	"continent": "North America",
	"country": "Grenada",
	"region": "gd"
}, {
	"continent": "South America",
	"country": "French Guiana",
	"region": "gf"
}, {
	"continent": "Europe",
	"country": "Guernsey",
	"region": "gg"
}, {
	"continent": "Africa",
	"country": "Ghana",
	"region": "gh"
}, {
	"continent": "Europe",
	"country": "Gibraltar",
	"region": "gi"
}, {
	"continent": "North America",
	"country": "Greenland",
	"region": "gl"
}, {
	"continent": "Africa",
	"country": "Gambia",
	"region": "gm"
}, {
	"continent": "Africa",
	"country": "Guinea",
	"region": "gn"
}, {
	"continent": "Africa",
	"country": "Glorioso Islands",
	"region": "go"
}, {
	"continent": "North America",
	"country": "Guadeloupe",
	"region": "gp"
}, {
	"continent": "Africa",
	"country": "Equatorial Guinea",
	"region": "gq"
}, {
	"continent": "Europe",
	"country": "Greece",
	"region": "gr"
}, {
	"continent": "Antarctica",
	"country": "South Georgia and South Sandwich Islands",
	"region": "gs"
}, {
	"continent": "North America",
	"country": "Guatemala",
	"region": "gt"
}, {
	"continent": "Oceania",
	"country": "Guam",
	"region": "gu"
}, {
	"continent": "Africa",
	"country": "Guinea-Bissau",
	"region": "gw"
}, {
	"continent": "South America",
	"country": "Guyana",
	"region": "gy"
}, {
	"continent": "Asia",
	"country": "Hong Kong",
	"region": "hk"
}, {
	"continent": "Antarctica",
	"country": "Heard Island and McDonald Islands",
	"region": "hm"
}, {
	"continent": "North America",
	"country": "Honduras",
	"region": "hn"
}, {
	"continent": "Europe",
	"country": "Croatia",
	"region": "hr"
}, {
	"continent": "North America",
	"country": "Haiti",
	"region": "ht"
}, {
	"continent": "Europe",
	"country": "Hungary",
	"region": "hu"
}, {
	"continent": "Asia",
	"country": "Indonesia",
	"region": "id"
}, {
	"continent": "Europe",
	"country": "Ireland",
	"region": "ie"
}, {
	"continent": "Asia",
	"country": "Israel",
	"region": "il"
}, {
	"continent": "Europe",
	"country": "Isle of Man",
	"region": "im"
}, {
	"continent": "Asia",
	"country": "India",
	"region": "in"
}, {
	"continent": "Europe",
	"country": "British Indian Ocean Territory",
	"region": "io"
}, {
	"continent": "Asia",
	"country": "Iraq",
	"region": "iq"
}, {
	"continent": "Asia",
	"country": "Iran",
	"region": "ir"
}, {
	"continent": "Europe",
	"country": "Iceland",
	"region": "is"
}, {
	"continent": "Europe",
	"country": "Italy",
	"region": "it"
}, {
	"continent": "Europe",
	"country": "Jersey",
	"region": "je"
}, {
	"continent": "North America",
	"country": "Jamaica",
	"region": "jm"
}, {
	"continent": "Asia",
	"country": "Jordan",
	"region": "jo"
}, {
	"continent": "Asia",
	"country": "Japan",
	"region": "jp"
}, {
	"continent": "Antarctica",
	"country": "Juan De Nova Island",
	"region": "ju"
}, {
	"continent": "Africa",
	"country": "Kenya",
	"region": "ke"
}, {
	"continent": "Asia",
	"country": "Kyrgyzstan",
	"region": "kg"
}, {
	"continent": "Asia",
	"country": "Cambodia",
	"region": "kh"
}, {
	"continent": "Oceania",
	"country": "Kiribati",
	"region": "ki"
}, {
	"continent": "Africa",
	"country": "Comoros",
	"region": "km"
}, {
	"continent": "North America",
	"country": "Saint Kitts and Nevis",
	"region": "kn"
}, {
	"continent": "Asia",
	"country": "North Korea",
	"region": "kp"
}, {
	"continent": "Asia",
	"country": "South Korea",
	"region": "kr"
}, {
	"continent": "Europe",
	"country": "Kosovo",
	"region": "xk"
}, {
	"continent": "Asia",
	"country": "Kuwait",
	"region": "kw"
}, {
	"continent": "North America",
	"country": "Cayman Islands",
	"region": "ky"
}, {
	"continent": "Asia",
	"country": "Kazakhstan",
	"region": "kz"
}, {
	"continent": "Asia",
	"country": "Laos",
	"region": "la"
}, {
	"continent": "Asia",
	"country": "Lebanon",
	"region": "lb"
}, {
	"continent": "North America",
	"country": "Saint Lucia",
	"region": "lc"
}, {
	"continent": "Europe",
	"country": "Liechtenstein",
	"region": "li"
}, {
	"continent": "Asia",
	"country": "Sri Lanka",
	"region": "lk"
}, {
	"continent": "Africa",
	"country": "Liberia",
	"region": "lr"
}, {
	"continent": "Africa",
	"country": "Lesotho",
	"region": "ls"
}, {
	"continent": "Europe",
	"country": "Lithuania",
	"region": "lt"
}, {
	"continent": "Europe",
	"country": "Luxembourg",
	"region": "lu"
}, {
	"continent": "Europe",
	"country": "Latvia",
	"region": "lv"
}, {
	"continent": "Africa",
	"country": "Libya",
	"region": "ly"
}, {
	"continent": "Africa",
	"country": "Morocco",
	"region": "ma"
}, {
	"continent": "Europe",
	"country": "Monaco",
	"region": "mc"
}, {
	"continent": "Europe",
	"country": "Moldova",
	"region": "md"
}, {
	"continent": "Africa",
	"country": "Madagascar",
	"region": "mg"
}, {
	"continent": "Europe",
	"country": "Montenegro",
	"region": "me"
}, {
	"continent": "North America",
	"country": "Saint Martin",
	"region": "mf"
}, {
	"continent": "Oceania",
	"country": "Marshall Islands",
	"region": "mh"
}, {
	"continent": "Europe",
	"country": "Macedonia",
	"region": "mk"
}, {
	"continent": "Africa",
	"country": "Mali",
	"region": "ml"
}, {
	"continent": "Asia",
	"country": "Macau",
	"region": "mo"
}, {
	"continent": "Asia",
	"country": "Myanmar",
	"region": "mm"
}, {
	"continent": "Asia",
	"country": "Mongolia",
	"region": "mn"
}, {
	"continent": "Oceania",
	"country": "Northern Mariana Islands",
	"region": "mp"
}, {
	"continent": "North America",
	"country": "Martinique",
	"region": "mq"
}, {
	"continent": "Africa",
	"country": "Mauritania",
	"region": "mr"
}, {
	"continent": "North America",
	"country": "Montserrat",
	"region": "ms"
}, {
	"continent": "Europe",
	"country": "Malta",
	"region": "mt"
}, {
	"continent": "Africa",
	"country": "Mauritius",
	"region": "mu"
}, {
	"continent": "Asia",
	"country": "Maldives",
	"region": "mv"
}, {
	"continent": "Africa",
	"country": "Malawi",
	"region": "mw"
}, {
	"continent": "North America",
	"country": "Mexico",
	"region": "mx"
}, {
	"continent": "Asia",
	"country": "Malaysia",
	"region": "my"
}, {
	"continent": "Africa",
	"country": "Mozambique",
	"region": "mz"
}, {
	"continent": "Africa",
	"country": "Namibia",
	"region": "na"
}, {
	"continent": "UNKOceaniaNoWN",
	"country": "New Caledonia",
	"region": "nc"
}, {
	"continent": "Africa",
	"country": "Niger",
	"region": "ne"
}, {
	"continent": "Oceania",
	"country": "Norfolk Island",
	"region": "nf"
}, {
	"continent": "Africa",
	"country": "Nigeria",
	"region": "ng"
}, {
	"continent": "North America",
	"country": "Nicaragua",
	"region": "ni"
}, {
	"continent": "Europe",
	"country": "Netherlands",
	"region": "nl"
}, {
	"continent": "Europe",
	"country": "Norway",
	"region": "no"
}, {
	"continent": "Asia",
	"country": "Nepal",
	"region": "np"
}, {
	"continent": "Oceania",
	"country": "Nauru",
	"region": "nr"
}, {
	"continent": "Oceania",
	"country": "Niue",
	"region": "nu"
}, {
	"continent": "Oceania",
	"country": "New Zealand",
	"region": "nz"
}, {
	"continent": "Asia",
	"country": "Oman",
	"region": "om"
}, {
	"continent": "North America",
	"country": "Panama",
	"region": "pa"
}, {
	"continent": "South America",
	"country": "Peru",
	"region": "pe"
}, {
	"continent": "Oceania",
	"country": "French Polynesia",
	"region": "pf"
}, {
	"continent": "Oceania",
	"country": "Papua New Guinea",
	"region": "pg"
}, {
	"continent": "Asia",
	"country": "Philippines",
	"region": "ph"
}, {
	"continent": "Asia",
	"country": "Pakistan",
	"region": "pk"
}, {
	"continent": "Europe",
	"country": "Poland",
	"region": "pl"
}, {
	"continent": "North America",
	"country": "Saint Pierre and Miquelon",
	"region": "pm"
}, {
	"continent": "Oceania",
	"country": "Pitcairn Islands",
	"region": "pn"
}, {
	"continent": "North America",
	"country": "Puerto Rico",
	"region": "pr"
}, {
	"continent": "Asia",
	"country": "Palestinian Territories",
	"region": "ps"
}, {
	"continent": "Europe",
	"country": "Portugal",
	"region": "pt"
}, {
	"continent": "Oceania",
	"country": "Palau",
	"region": "pw"
}, {
	"continent": "South America",
	"country": "Paraguay",
	"region": "py"
}, {
	"continent": "Asia",
	"country": "Qatar",
	"region": "qa"
}, {
	"continent": "Africa",
	"country": "Reunion",
	"region": "re"
}, {
	"continent": "Europe",
	"country": "Romania",
	"region": "ro"
}, {
	"continent": "Europe",
	"country": "Serbia",
	"region": "rs"
}, {
	"continent": "Europe",
	"country": "Russia",
	"region": "ru"
}, {
	"continent": "Africa",
	"country": "Rwanda",
	"region": "rw"
}, {
	"continent": "Asia",
	"country": "Saudi Arabia",
	"region": "sa"
}, {
	"continent": "Oceania",
	"country": "Solomon Islands",
	"region": "sb"
}, {
	"continent": "Africa",
	"country": "Seychelles",
	"region": "sc"
}, {
	"continent": "Africa",
	"country": "Sudan",
	"region": "sd"
}, {
	"continent": "Europe",
	"country": "Sweden",
	"region": "se"
}, {
	"continent": "Asia",
	"country": "Singapore",
	"region": "sg"
}, {
	"continent": "Africa",
	"country": "Saint Helena",
	"region": "sh"
}, {
	"continent": "Europe",
	"country": "Slovenia",
	"region": "si"
}, {
	"continent": "Europe",
	"country": "Svalbard and Jan Mayen",
	"region": "sj"
}, {
	"continent": "Europe",
	"country": "Slovakia",
	"region": "sk"
}, {
	"continent": "Africa",
	"country": "Sierra Leone",
	"region": "sl"
}, {
	"continent": "Europe",
	"country": "San Marino",
	"region": "sm"
}, {
	"continent": "Africa",
	"country": "Senegal",
	"region": "sn"
}, {
	"continent": "Africa",
	"country": "Somalia",
	"region": "so"
}, {
	"continent": "South America",
	"country": "Suriname",
	"region": "sr"
}, {
	"continent": "Africa",
	"country": "South Sudan",
	"region": "ss"
}, {
	"continent": "Africa",
	"country": "Sao Tome and Principe",
	"region": "st"
}, {
	"continent": "North America",
	"country": "El Salvador",
	"region": "sv"
}, {
	"continent": "North America",
	"country": "Saint Martin",
	"region": "sx"
}, {
	"continent": "Asia",
	"country": "Syria",
	"region": "sy"
}, {
	"continent": "Africa",
	"country": "Swaziland",
	"region": "sz"
}, {
	"continent": "North America",
	"country": "Turks and Caicos Islands",
	"region": "tc"
}, {
	"continent": "Africa",
	"country": "Chad",
	"region": "td"
}, {
	"continent": "Antarctica ",
	"country": "French Southern and Antarctic Lands",
	"region": "tf"
}, {
	"continent": "Africa",
	"country": "Togo",
	"region": "tg"
}, {
	"continent": "Asia",
	"country": "Thailand",
	"region": "th"
}, {
	"continent": "Asia",
	"country": "Tajikistan",
	"region": "tj"
}, {
	"continent": "Oceania",
	"country": "Tokelau",
	"region": "tk"
}, {
	"continent": "Asia",
	"country": "Timor-Leste",
	"region": "tl"
}, {
	"continent": "Asia",
	"country": "Turkmenistan",
	"region": "tm"
}, {
	"continent": "Africa",
	"country": "Tunisia",
	"region": "tn"
}, {
	"continent": "Oceania",
	"country": "Tonga",
	"region": "to"
}, {
	"continent": "Asia",
	"country": "Turkey",
	"region": "tr"
}, {
	"continent": "North America",
	"country": "Trinidad and Tobago",
	"region": "tt"
}, {
	"continent": "Oceania",
	"country": "Tuvalu",
	"region": "tv"
}, {
	"continent": "Asia",
	"country": "Taiwan",
	"region": "tw"
}, {
	"continent": "Africa",
	"country": "Tanzania",
	"region": "tz"
}, {
	"continent": "Europe",
	"country": "Ukraine",
	"region": "ua"
}, {
	"continent": "Africa",
	"country": "Uganda",
	"region": "ug"
}, {
	"continent": "Oceania",
	"country": "Jarvis Island",
	"region": "um-dq"
}, {
	"continent": "Oceania",
	"country": "Baker Island",
	"region": "um-fq"
}, {
	"continent": "Oceania",
	"country": "Howland Island",
	"region": "um-hq"
}, {
	"continent": "Oceania",
	"country": "Johnston Atoll",
	"region": "um-jq"
}, {
	"continent": "North America",
	"country": "Midway Islands",
	"region": "um-mq"
}, {
	"continent": "Oceania",
	"country": "Wake Island",
	"region": "um-wq"
}, {
	"continent": "North America",
	"country": "United States",
	"region": "us"
}, {
	"continent": "South America",
	"country": "Uruguay",
	"region": "uy"
}, {
	"continent": "Asia",
	"country": "Uzbekistan",
	"region": "uz"
}, {
	"continent": "Europe",
	"country": "Vatican City",
	"region": "va"
}, {
	"continent": "North America",
	"country": "Saint Vincent and the Grenadines",
	"region": "vc"
}, {
	"continent": "South America",
	"country": "Venezuela",
	"region": "ve"
}, {
	"continent": "North America",
	"country": "British Virgin Islands",
	"region": "vg"
}, {
	"continent": "North America",
	"country": "US Virgin Islands",
	"region": "vi"
}, {
	"continent": "Asia",
	"country": "Vietnam",
	"region": "vn"
}, {
	"continent": "Oceania",
	"country": "Vanuatu",
	"region": "vu"
}, {
	"continent": "Oceania",
	"country": "Wallis and Futuna",
	"region": "wf"
}, {
	"continent": "Oceania",
	"country": "Samoa",
	"region": "ws"
}, {
	"continent": "Asia",
	"country": "Yemen",
	"region": "ye"
}, {
	"continent": "Africa",
	"country": "Mayotte",
	"region": "yt"
}, {
	"continent": "Africa",
	"country": "South Africa",
	"region": "za"
}, {
	"continent": "Africa",
	"country": "Zambia",
	"region": "zm"
}, {
	"continent": "Africa",
	"country": "Zimbabwe",
	"region": "zw"
}
]
export const continents = ["Africa", "Asia", "Europe", "North America", "Oceania", "South America", "Antarctica"]
// export const countries_continents = [
// {continent: "Africa", country: "Algeria"},
// {continent: "Africa", country: "Angola"},
// {continent: "Africa", country: "Benin"},
// {continent: "Africa", country: "Botswana"},
// {continent: "Africa", country: "Burkina"},
// {continent: "Africa", country: "Burundi"},
// {continent: "Africa", country: "Cameroon"},
// {continent: "Africa", country: "Cape Verde"},
// {continent: "Africa", country: "Central African Republic"},
// {continent: "Africa", country: "Chad"},
// {continent: "Africa", country: "Comoros"},
// {continent: "Africa", country: "Congo"},
// {continent: "Africa", country: "Congo"},
// {continent: "Africa", country: "Djibouti"},
// {continent: "Africa", country: "Egypt"},
// {continent: "Africa", country: "Equatorial Guinea"},
// {continent: "Africa", country: "Eritrea"},
// {continent: "Africa", country: "Ethiopia"},
// {continent: "Africa", country: "Gabon"},
// {continent: "Africa", country: "Gambia"},
// {continent: "Africa", country: "Ghana"},
// {continent: "Africa", country: "Guinea"},
// {continent: "Africa", country: "Guinea-Bissau"},
// {continent: "Africa", country: "Ivory Coast"},
// {continent: "Africa", country: "Kenya"},
// {continent: "Africa", country: "Lesotho"},
// {continent: "Africa", country: "Liberia"},
// {continent: "Africa", country: "Libya"},
// {continent: "Africa", country: "Madagascar"},
// {continent: "Africa", country: "Malawi"},
// {continent: "Africa", country: "Mali"},
// {continent: "Africa", country: "Mauritania"},
// {continent: "Africa", country: "Mauritius"},
// {continent: "Africa", country: "Morocco"},
// {continent: "Africa", country: "Mozambique"},
// {continent: "Africa", country: "Namibia"},
// {continent: "Africa", country: "Niger"},
// {continent: "Africa", country: "Nigeria"},
// {continent: "Africa", country: "Rwanda"},
// {continent: "Africa", country: "Sao Tome and Principe"},
// {continent: "Africa", country: "Senegal"},
// {continent: "Africa", country: "Seychelles"},
// {continent: "Africa", country: "Sierra Leone"},
// {continent: "Africa", country: "Somalia"},
// {continent: "Africa", country: "South Africa"},
// {continent: "Africa", country: "South Sudan"},
// {continent: "Africa", country: "Sudan"},
// {continent: "Africa", country: "Swaziland"},
// {continent: "Africa", country: "Tanzania"},
// {continent: "Africa", country: "Togo"},
// {continent: "Africa", country: "Tunisia"},
// {continent: "Africa", country: "Uganda"},
// {continent: "Africa", country: "Zambia"},
// {continent: "Africa", country: "Zimbabwe"},
// {continent: "Asia", country: "Afghanistan"},
// {continent: "Asia", country: "Bahrain"},
// {continent: "Asia", country: "Bangladesh"},
// {continent: "Asia", country: "Bhutan"},
// {continent: "Asia", country: "Brunei"},
// {continent: "Asia", country: "Burma (Myanmar)"},
// {continent: "Asia", country: "Cambodia"},
// {continent: "Asia", country: "China"},
// {continent: "Asia", country: "East Timor"},
// {continent: "Asia", country: "India"},
// {continent: "Asia", country: "Indonesia"},
// {continent: "Asia", country: "Iran"},
// {continent: "Asia", country: "Iraq"},
// {continent: "Asia", country: "Israel"},
// {continent: "Asia", country: "Japan"},
// {continent: "Asia", country: "Jordan"},
// {continent: "Asia", country: "Kazakhstan"},
// {continent: "Asia", country: "North Korea"},
// {continent: "Asia", country: "South Korea",},
// {continent: "Asia", country: "Kuwait"},
// {continent: "Asia", country: "Kyrgyzstan"},
// {continent: "Asia", country: "Laos"},
// {continent: "Asia", country: "Lebanon"},
// {continent: "Asia", country: "Malaysia"},
// {continent: "Asia", country: "Maldives"},
// {continent: "Asia", country: "Mongolia"},
// {continent: "Asia", country: "Nepal"},
// {continent: "Asia", country: "Oman"},
// {continent: "Asia", country: "Pakistan"},
// {continent: "Asia", country: "Philippines"},
// {continent: "Asia", country: "Qatar"},
// {continent: "Asia", country: "Russian Federation"},
// {continent: "Asia", country: "Saudi Arabia"},
// {continent: "Asia", country: "Singapore"},
// {continent: "Asia", country: "Sri Lanka"},
// {continent: "Asia", country: "Syria"},
// {continent: "Asia", country: "Tajikistan"},
// {continent: "Asia", country: "Thailand"},
// {continent: "Asia", country: "Turkey"},
// {continent: "Asia", country: "Turkmenistan"},
// {continent: "Asia", country: "United Arab Emirates"},
// {continent: "Asia", country: "Uzbekistan"},
// {continent: "Asia", country: "Vietnam"},
// {continent: "Asia", country: "Yemen"},
// {continent: "Europe", country: "Albania"},
// {continent: "Europe", country: "Andorra"},
// {continent: "Europe", country: "Armenia"},
// {continent: "Europe", country: "Austria"},
// {continent: "Europe", country: "Azerbaijan"},
// {continent: "Europe", country: "Belarus"},
// {continent: "Europe", country: "Belgium"},
// {continent: "Europe", country: "Bosnia and Herzegovina"},
// {continent: "Europe", country: "Bulgaria"},
// {continent: "Europe", country: "Croatia"},
// {continent: "Europe", country: "Cyprus"},
// {continent: "Europe", country: "CZ"},
// {continent: "Europe", country: "Denmark"},
// {continent: "Europe", country: "Estonia"},
// {continent: "Europe", country: "Finland"},
// {continent: "Europe", country: "France"},
// {continent: "Europe", country: "Georgia"},
// {continent: "Europe", country: "Germany"},
// {continent: "Europe", country: "Greece"},
// {continent: "Europe", country: "Hungary"},
// {continent: "Europe", country: "Iceland"},
// {continent: "Europe", country: "Ireland"},
// {continent: "Europe", country: "Italy"},
// {continent: "Europe", country: "Latvia"},
// {continent: "Europe", country: "Liechtenstein"},
// {continent: "Europe", country: "Lithuania"},
// {continent: "Europe", country: "Luxembourg"},
// {continent: "Europe", country: "Macedonia"},
// {continent: "Europe", country: "Malta"},
// {continent: "Europe", country: "Moldova"},
// {continent: "Europe", country: "Monaco"},
// {continent: "Europe", country: "Montenegro"},
// {continent: "Europe", country: "Netherlands"},
// {continent: "Europe", country: "Norway"},
// {continent: "Europe", country: "Poland"},
// {continent: "Europe", country: "Portugal"},
// {continent: "Europe", country: "Romania"},
// {continent: "Europe", country: "San Marino"},
// {continent: "Europe", country: "Serbia"},
// {continent: "Europe", country: "Slovakia"},
// {continent: "Europe", country: "Slovenia"},
// {continent: "Europe", country: "Spain"},
// {continent: "Europe", country: "Sweden"},
// {continent: "Europe", country: "Switzerland"},
// {continent: "Europe", country: "Ukraine"},
// {continent: "Europe", country: "United Kingdom"},
// {continent: "Europe", country: "Vatican City"},
// {continent: "North America", country: "Antigua and Barbuda"},
// {continent: "North America", country: "Bahamas"},
// {continent: "North America", country: "Barbados"},
// {continent: "North America", country: "Belize"},
// {continent: "North America", country: "Canada"},
// {continent: "North America", country: "Costa Rica"},
// {continent: "North America", country: "Cuba"},
// {continent: "North America", country: "Dominica"},
// {continent: "North America", country: "Dominican Republic"},
// {continent: "North America", country: "El Salvador"},
// {continent: "North America", country: "Grenada"},
// {continent: "North America", country: "Guatemala"},
// {continent: "North America", country: "Haiti"},
// {continent: "North America", country: "Honduras"},
// {continent: "North America", country: "Jamaica"},
// {continent: "North America", country: "Mexico"},
// {continent: "North America", country: "Nicaragua"},
// {continent: "North America", country: "Panama"},
// {continent: "North America", country: "Saint Kitts and Nevis"},
// {continent: "North America", country: "Saint Lucia"},
// {continent: "North America", country: "Saint Vincent and the Grenadines"},
// {continent: "North America", country: "Trinidad and Tobago"},
// {continent: "North America", country: "USA"},
// {continent: "Oceania", country: "Australia"},
// {continent: "Oceania", country: "Fiji"},
// {continent: "Oceania", country: "Kiribati"},
// {continent: "Oceania", country: "Marshall Islands"},
// {continent: "Oceania", country: "Micronesia"},
// {continent: "Oceania", country: "Nauru"},
// {continent: "Oceania", country: "New Zealand"},
// {continent: "Oceania", country: "Palau"},
// {continent: "Oceania", country: "Papua New Guinea"},
// {continent: "Oceania", country: "Samoa"},
// {continent: "Oceania", country: "Solomon Islands"},
// {continent: "Oceania", country: "Tonga"},
// {continent: "Oceania", country: "Tuvalu"},
// {continent: "Oceania", country: "Vanuatu"},
// {continent: "South America", country: "Argentina"},
// {continent: "South America", country: "Bolivia"},
// {continent: "South America", country: "Brazil"},
// {continent: "South America", country: "Chile"},
// {continent: "South America", country: "Colombia"},
// {continent: "South America", country: "Ecuador"},
// {continent: "South America", country: "Guyana"},
// {continent: "South America", country: "Paraguay"},
// {continent: "South America", country: "Peru"},
// {continent: "South America", country: "Suriname"},
// {continent: "South America", country: "Uruguay"},
// {continent: "South America", country: "Venezuela"},
// ];

export const regions = [

		{
			"id": "ad",
			"name": "Andorra"
		},
		{
			"id": "ae",
			"name": "United Arab Emirates"
		},
		{
			"id": "af",
			"name": "Afghanistan"
		},
		{
			"id": "ag",
			"name": "Antigua and Barbuda"
		},
		{
			"id": "ai",
			"name": "Anguilla"
		},
		{
			"id": "al",
			"name": "Albania"
		},
		{
			"id": "am",
			"name": "Armenia"
		},
		{
			"id": "ao",
			"name": "Angola"
		},
		{
			"id": "ar",
			"name": "Argentina"
		},
		{
			"id": "as",
			"name": "American Samoa"
		},
		{
			"id": "at",
			"name": "Austria"
		},
		{
			"id": "au",
			"name": "Australia"
		},
		{
			"id": "aw",
			"name": "Aruba"
		},
		{
			"id": "ax",
			"name": "Aland Islands"
		},
		{
			"id": "az",
			"name": "Azerbaijan"
		},
		{
			"id": "ba",
			"name": "Bosnia and Herzegovina"
		},
		{
			"id": "bb",
			"name": "Barbados"
		},
		{
			"id": "bd",
			"name": "Bangladesh"
		},
		{
			"id": "be",
			"name": "Belgium"
		},
		{
			"id": "bf",
			"name": "Burkina Faso"
		},
		{
			"id": "bg",
			"name": "Bulgaria"
		},
		{
			"id": "bh",
			"name": "Bahrain"
		},
		{
			"id": "bi",
			"name": "Burundi"
		},
		{
			"id": "bj",
			"name": "Benin"
		},
		{
			"id": "bl",
			"name": "Saint Barthelemy"
		},
		{
			"id": "bn",
			"name": "Brunei Darussalam"
		},
		{
			"id": "bo",
			"name": "Bolivia"
		},
		{
			"id": "bm",
			"name": "Bermuda"
		},
		{
			"id": "bq",
			"name": "Bonaire, Saint Eustachius and Saba"
		},
		{
			"id": "br",
			"name": "Brazil"
		},
		{
			"id": "bs",
			"name": "Bahamas"
		},
		{
			"id": "bt",
			"name": "Bhutan"
		},
		{
			"id": "bv",
			"name": "Bouvet Island"
		},
		{
			"id": "bw",
			"name": "Botswana"
		},
		{
			"id": "by",
			"name": "Belarus"
		},
		{
			"id": "bz",
			"name": "Belize"
		},
		{
			"id": "ca",
			"name": "Canada"
		},
		{
			"id": "cc",
			"name": "Cocos (Keeling) Islands"
		},
		{
			"id": "cd",
			"name": "Congo"
		},
		{
			"id": "cf",
			"name": "Central African Republic"
		},
		{
			"id": "cg",
			"name": "Republic of Congo"
		},
		{
			"id": "ch",
			"name": "Switzerland"
		},
		{
			"id": "ci",
			"name": "Côte d'Ivoire"
		},
		{
			"id": "ck",
			"name": "Cook Islands"
		},
		{
			"id": "cl",
			"name": "Chile"
		},
		{
			"id": "cm",
			"name": "Cameroon"
		},
		{
			"id": "cn",
			"name": "China"
		},
		{
			"id": "co",
			"name": "Colombia"
		},
		{
			"id": "cr",
			"name": "Costa Rica"
		},
		{
			"id": "cu",
			"name": "Cuba"
		},
		{
			"id": "cv",
			"name": "Cape Verde"
		},
		{
			"id": "cw",
			"name": "Curaçao"
		},
		{
			"id": "cx",
			"name": "Christmas Island"
		},
		{
			"id": "cy",
			"name": "Cyprus"
		},
		{
			"id": "cz",
			"name": "Czech Republic"
		},
		{
			"id": "de",
			"name": "Germany"
		},
		{
			"id": "dj",
			"name": "Djibouti"
		},
		{
			"id": "dk",
			"name": "Denmark"
		},
		{
			"id": "dm",
			"name": "Dominica"
		},
		{
			"id": "do",
			"name": "Dominican Republic"
		},
		{
			"id": "dz",
			"name": "Algeria"
		},
		{
			"id": "ec",
			"name": "Ecuador"
		},
		{
			"id": "eg",
			"name": "Egypt"
		},
		{
			"id": "ee",
			"name": "Estonia"
		},
		{
			"id": "eh",
			"name": "Western Sahara"
		},
		{
			"id": "er",
			"name": "Eritrea"
		},
		{
			"id": "es",
			"name": "Spain"
		},
		{
			"id": "et",
			"name": "Ethiopia"
		},
		{
			"id": "fi",
			"name": "Finland"
		},
		{
			"id": "fj",
			"name": "Fiji"
		},
		{
			"id": "fk",
			"name": "Falkland Islands"
		},
		{
			"id": "fm",
			"name": "Micronesia"
		},
		{
			"id": "fo",
			"name": "Faroe Islands"
		},
		{
			"id": "fr",
			"name": "France"
		},
		{
			"id": "ga",
			"name": "Gabon"
		},
		{
			"id": "gb",
			"name": "United Kingdom"
		},
		{
			"id": "ge",
			"name": "Georgia"
		},
		{
			"id": "gd",
			"name": "Grenada"
		},
		{
			"id": "gf",
			"name": "French Guiana"
		},
		{
			"id": "gg",
			"name": "Guernsey"
		},
		{
			"id": "gh",
			"name": "Ghana"
		},
		{
			"id": "gi",
			"name": "Gibraltar"
		},
		{
			"id": "gl",
			"name": "Greenland"
		},
		{
			"id": "gm",
			"name": "Gambia"
		},
		{
			"id": "gn",
			"name": "Guinea"
		},
		{
			"id": "go",
			"name": "Glorioso Islands"
		},
		{
			"id": "gp",
			"name": "Guadeloupe"
		},
		{
			"id": "gq",
			"name": "Equatorial Guinea"
		},
		{
			"id": "gr",
			"name": "Greece"
		},
		{
			"id": "gs",
			"name": "South Georgia and South Sandwich Islands"
		},
		{
			"id": "gt",
			"name": "Guatemala"
		},
		{
			"id": "gu",
			"name": "Guam"
		},
		{
			"id": "gw",
			"name": "Guinea-Bissau"
		},
		{
			"id": "gy",
			"name": "Guyana"
		},
		{
			"id": "hk",
			"name": "Hong Kong"
		},
		{
			"id": "hm",
			"name": "Heard Island and McDonald Islands"
		},
		{
			"id": "hn",
			"name": "Honduras"
		},
		{
			"id": "hr",
			"name": "Croatia"
		},
		{
			"id": "ht",
			"name": "Haiti"
		},
		{
			"id": "hu",
			"name": "Hungary"
		},
		{
			"id": "id",
			"name": "Indonesia"
		},
		{
			"id": "ie",
			"name": "Ireland"
		},
		{
			"id": "il",
			"name": "Israel"
		},
		{
			"id": "im",
			"name": "Isle of Man"
		},
		{
			"id": "in",
			"name": "India"
		},
		{
			"id": "io",
			"name": "British Indian Ocean Territory"
		},
		{
			"id": "iq",
			"name": "Iraq"
		},
		{
			"id": "ir",
			"name": "Iran"
		},
		{
			"id": "is",
			"name": "Iceland"
		},
		{
			"id": "it",
			"name": "Italy"
		},
		{
			"id": "je",
			"name": "Jersey"
		},
		{
			"id": "jm",
			"name": "Jamaica"
		},
		{
			"id": "jo",
			"name": "Jordan"
		},
		{
			"id": "jp",
			"name": "Japan"
		},
		{
			"id": "ju",
			"name": "Juan De Nova Island"
		},
		{
			"id": "ke",
			"name": "Kenya"
		},
		{
			"id": "kg",
			"name": "Kyrgyzstan"
		},
		{
			"id": "kh",
			"name": "Cambodia"
		},
		{
			"id": "ki",
			"name": "Kiribati"
		},
		{
			"id": "km",
			"name": "Comoros"
		},
		{
			"id": "kn",
			"name": "Saint Kitts and Nevis"
		},
		{
			"id": "kp",
			"name": "North Korea"
		},
		{
			"id": "kr",
			"name": "South Korea"
		},
		{
			"id": "xk",
			"name": "Kosovo"
		},
		{
			"id": "kw",
			"name": "Kuwait"
		},
		{
			"id": "ky",
			"name": "Cayman Islands"
		},
		{
			"id": "kz",
			"name": "Kazakhstan"
		},
		{
			"id": "la",
			"name": "Laos"
		},
		{
			"id": "lb",
			"name": "Lebanon"
		},
		{
			"id": "lc",
			"name": "Saint Lucia"
		},
		{
			"id": "li",
			"name": "Liechtenstein"
		},
		{
			"id": "lk",
			"name": "Sri Lanka"
		},
		{
			"id": "lr",
			"name": "Liberia"
		},
		{
			"id": "ls",
			"name": "Lesotho"
		},
		{
			"id": "lt",
			"name": "Lithuania"
		},
		{
			"id": "lu",
			"name": "Luxembourg"
		},
		{
			"id": "lv",
			"name": "Latvia"
		},
		{
			"id": "ly",
			"name": "Libya"
		},
		{
			"id": "ma",
			"name": "Morocco"
		},
		{
			"id": "mc",
			"name": "Monaco"
		},
		{
			"id": "md",
			"name": "Moldova"
		},
		{
			"id": "mg",
			"name": "Madagascar"
		},
		{
			"id": "me",
			"name": "Montenegro"
		},
		{
			"id": "mf",
			"name": "Saint Martin"
		},
		{
			"id": "mh",
			"name": "Marshall Islands"
		},
		{
			"id": "mk",
			"name": "Macedonia"
		},
		{
			"id": "ml",
			"name": "Mali"
		},
		{
			"id": "mo",
			"name": "Macau"
		},
		{
			"id": "mm",
			"name": "Myanmar"
		},
		{
			"id": "mn",
			"name": "Mongolia"
		},
		{
			"id": "mp",
			"name": "Northern Mariana Islands"
		},
		{
			"id": "mq",
			"name": "Martinique"
		},
		{
			"id": "mr",
			"name": "Mauritania"
		},
		{
			"id": "ms",
			"name": "Montserrat"
		},
		{
			"id": "mt",
			"name": "Malta"
		},
		{
			"id": "mu",
			"name": "Mauritius"
		},
		{
			"id": "mv",
			"name": "Maldives"
		},
		{
			"id": "mw",
			"name": "Malawi"
		},
		{
			"id": "mx",
			"name": "Mexico"
		},
		{
			"id": "my",
			"name": "Malaysia"
		},
		{
			"id": "mz",
			"name": "Mozambique"
		},
		{
			"id": "na",
			"name": "Namibia"
		},
		{
			"id": "nc",
			"name": "New Caledonia"
		},
		{
			"id": "ne",
			"name": "Niger"
		},
		{
			"id": "nf",
			"name": "Norfolk Island"
		},
		{
			"id": "ng",
			"name": "Nigeria"
		},
		{
			"id": "ni",
			"name": "Nicaragua"
		},
		{
			"id": "nl",
			"name": "Netherlands"
		},
		{
			"id": "no",
			"name": "Norway"
		},
		{
			"id": "np",
			"name": "Nepal"
		},
		{
			"id": "nr",
			"name": "Nauru"
		},
		{
			"id": "nu",
			"name": "Niue"
		},
		{
			"id": "nz",
			"name": "New Zealand"
		},
		{
			"id": "om",
			"name": "Oman"
		},
		{
			"id": "pa",
			"name": "Panama"
		},
		{
			"id": "pe",
			"name": "Peru"
		},
		{
			"id": "pf",
			"name": "French Polynesia"
		},
		{
			"id": "pg",
			"name": "Papua New Guinea"
		},
		{
			"id": "ph",
			"name": "Philippines"
		},
		{
			"id": "pk",
			"name": "Pakistan"
		},
		{
			"id": "pl",
			"name": "Poland"
		},
		{
			"id": "pm",
			"name": "Saint Pierre and Miquelon"
		},
		{
			"id": "pn",
			"name": "Pitcairn Islands"
		},
		{
			"id": "pr",
			"name": "Puerto Rico"
		},
		{
			"id": "ps",
			"name": "Palestinian Territories"
		},
		{
			"id": "pt",
			"name": "Portugal"
		},
		{
			"id": "pw",
			"name": "Palau"
		},
		{
			"id": "py",
			"name": "Paraguay"
		},
		{
			"id": "qa",
			"name": "Qatar"
		},
		{
			"id": "re",
			"name": "Reunion"
		},
		{
			"id": "ro",
			"name": "Romania"
		},
		{
			"id": "rs",
			"name": "Serbia"
		},
		{
			"id": "ru",
			"name": "Russia"
		},
		{
			"id": "rw",
			"name": "Rwanda"
		},
		{
			"id": "sa",
			"name": "Saudi Arabia"
		},
		{
			"id": "sb",
			"name": "Solomon Islands"
		},
		{
			"id": "sc",
			"name": "Seychelles"
		},
		{
			"id": "sd",
			"name": "Sudan"
		},
		{
			"id": "se",
			"name": "Sweden"
		},
		{
			"id": "sg",
			"name": "Singapore"
		},
		{
			"id": "sh",
			"name": "Saint Helena"
		},
		{
			"id": "si",
			"name": "Slovenia"
		},
		{
			"id": "sj",
			"name": "Svalbard and Jan Mayen"
		},
		{
			"id": "sk",
			"name": "Slovakia"
		},
		{
			"id": "sl",
			"name": "Sierra Leone"
		},
		{
			"id": "sm",
			"name": "San Marino"
		},
		{
			"id": "sn",
			"name": "Senegal"
		},
		{
			"id": "so",
			"name": "Somalia"
		},
		{
			"id": "sr",
			"name": "Suriname"
		},
		{
			"id": "ss",
			"name": "South Sudan"
		},
		{
			"id": "st",
			"name": "Sao Tome and Principe"
		},
		{
			"id": "sv",
			"name": "El Salvador"
		},
		{
			"id": "sx",
			"name": "Saint Martin"
		},
		{
			"id": "sy",
			"name": "Syria"
		},
		{
			"id": "sz",
			"name": "Swaziland"
		},
		{
			"id": "tc",
			"name": "Turks and Caicos Islands"
		},
		{
			"id": "td",
			"name": "Chad"
		},
		{
			"id": "tf",
			"name": "French Southern and Antarctic Lands"
		},
		{
			"id": "tg",
			"name": "Togo"
		},
		{
			"id": "th",
			"name": "Thailand"
		},
		{
			"id": "tj",
			"name": "Tajikistan"
		},
		{
			"id": "tk",
			"name": "Tokelau"
		},
		{
			"id": "tl",
			"name": "Timor-Leste"
		},
		{
			"id": "tm",
			"name": "Turkmenistan"
		},
		{
			"id": "tn",
			"name": "Tunisia"
		},
		{
			"id": "to",
			"name": "Tonga"
		},
		{
			"id": "tr",
			"name": "Turkey"
		},
		{
			"id": "tt",
			"name": "Trinidad and Tobago"
		},
		{
			"id": "tv",
			"name": "Tuvalu"
		},
		{
			"id": "tw",
			"name": "Taiwan"
		},
		{
			"id": "tz",
			"name": "Tanzania"
		},
		{
			"id": "ua",
			"name": "Ukraine"
		},
		{
			"id": "ug",
			"name": "Uganda"
		},
		{
			"id": "um-dq",
			"name": "Jarvis Island"
		},
		{
			"id": "um-fq",
			"name": "Baker Island"
		},
		{
			"id": "um-hq",
			"name": "Howland Island"
		},
		{
			"id": "um-jq",
			"name": "Johnston Atoll"
		},
		{
			"id": "um-mq",
			"name": "Midway Islands"
		},
		{
			"id": "um-wq",
			"name": "Wake Island"
		},
		{
			"id": "us",
			"name": "United States"
		},
		{
			"id": "uy",
			"name": "Uruguay"
		},
		{
			"id": "uz",
			"name": "Uzbekistan"
		},
		{
			"id": "va",
			"name": "Vatican City"
		},
		{
			"id": "vc",
			"name": "Saint Vincent and the Grenadines"
		},
		{
			"id": "ve",
			"name": "Venezuela"
		},
		{
			"id": "vg",
			"name": "British Virgin Islands"
		},
		{
			"id": "vi",
			"name": "US Virgin Islands"
		},
		{
			"id": "vn",
			"name": "Vietnam"
		},
		{
			"id": "vu",
			"name": "Vanuatu"
		},
		{
			"id": "wf",
			"name": "Wallis and Futuna"
		},
		{
			"id": "ws",
			"name": "Samoa"
		},
		{
			"id": "ye",
			"name": "Yemen"
		},
		{
			"id": "yt",
			"name": "Mayotte"
		},
		{
			"id": "za",
			"name": "South Africa"
		},
		{
			"id": "zm",
			"name": "Zambia"
		},
		{
			"id": "zw",
			"name": "Zimbabwe"
		}
	]

